var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    transform: "matrix(1 0 0 -1 0 34)",
    fill: "#F26A1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3981 17C10.3982 17.2455 10.4958 17.4808 10.6694 17.6544C10.843 17.828 11.0783 17.9256 11.3238 17.9257L16.0737 17.9266L16.0746 22.6765C16.0746 22.7981 16.0985 22.9184 16.145 23.0307C16.1916 23.1431 16.2598 23.2451 16.3457 23.3311C16.4317 23.417 16.5337 23.4852 16.646 23.5317C16.7583 23.5783 16.8787 23.6022 17.0003 23.6022C17.1219 23.6022 17.2422 23.5783 17.3545 23.5317C17.4669 23.4852 17.5689 23.417 17.6549 23.3311C17.7408 23.2451 17.809 23.1431 17.8555 23.0307C17.9021 22.9184 17.926 22.7981 17.926 22.6765L17.9269 17.9266L22.6768 17.9257C22.9223 17.9257 23.1578 17.8282 23.3314 17.6546C23.505 17.481 23.6025 17.2455 23.6025 17C23.6025 16.7545 23.505 16.519 23.3314 16.3454C23.1578 16.1718 22.9223 16.0743 22.6768 16.0743L17.9269 16.0734L17.926 11.3235C17.926 11.078 17.8285 10.8425 17.6549 10.6689C17.4813 10.4953 17.2458 10.3978 17.0003 10.3978C16.7548 10.3978 16.5193 10.4953 16.3457 10.6689C16.1721 10.8425 16.0746 11.078 16.0746 11.3235L16.0737 16.0734L11.3238 16.0743C11.0783 16.0744 10.843 16.172 10.6694 16.3456C10.4958 16.5192 10.3982 16.7545 10.3981 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.6dc4403f4677698672c7e922c07a83c0.svg";
export { ForwardRef as ReactComponent };